import TimerEditor from './TimerEditor'

export default TimerEditor
